module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsSAAALEgHS3X78AAAAV0lEQVRIiWMYBUMT/P//X+D///8BNHM8yPD/EJBAS0sSRi0ZGpawoClqoNCeCwwMDPP////PwMjIuAAkwEShgfQDNI3sUcMHxHDaFnY0L65HAfUAAwMDAMp5la8ABYQLAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/@1x/ic_btn_arrow.png
// module id = 714
// module chunks = 0